import { useEffect } from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import LeadForm from "@/components/site/LeadForm";
import { Reveal } from "@/components/site/motion";
import { CONTACT } from "@/data/content";

const ContactPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const details = [
    { icon: Phone, label: "Call us now", value: CONTACT.phone, href: CONTACT.phoneHref },
    { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: MapPin, label: "Visit", value: `${CONTACT.address_line1}, ${CONTACT.address_line2}` },
    { icon: Clock, label: "Availability", value: "Admissions line open 24/7" },
  ];

  return (
    <div data-testid="contact-page" className="bg-sand min-h-screen">
      <Navbar />
      <section className="pt-40 md:pt-48 pb-16 md:pb-24">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-2 gap-14">
          <div>
            <Reveal>
              <p className="text-sm uppercase tracking-[0.25em] text-terracotta mb-4">Contact Us</p>
              <h1 className="font-serif text-5xl md:text-7xl text-forest tracking-tight leading-[0.98]">Let’s talk, confidentially</h1>
              <p className="mt-6 text-lg text-ink2 leading-relaxed max-w-lg">
                You are not alone. Reach out any time — our caring admissions team is here 24/7 with immediate admittance and shorter wait lists.
              </p>
            </Reveal>

            <div className="mt-10 grid sm:grid-cols-2 gap-5">
              {details.map((d) => {
                const Icon = d.icon;
                const inner = (
                  <div className="flex items-start gap-4">
                    <span className="grid place-items-center w-11 h-11 rounded-full bg-sage/25 text-forest shrink-0"><Icon className="w-5 h-5" /></span>
                    <span>
                      <span className="block text-xs uppercase tracking-[0.15em] text-ink2">{d.label}</span>
                      <span className="block text-forest font-semibold mt-0.5">{d.value}</span>
                    </span>
                  </div>
                );
                return d.href ? (
                  <a key={d.label} href={d.href} className="block hover:opacity-80 transition-opacity">{inner}</a>
                ) : (
                  <div key={d.label}>{inner}</div>
                );
              })}
            </div>

            <div className="mt-10 rounded-3xl overflow-hidden border border-line h-[300px]">
              <iframe
                title="New Beginnings Recovery location"
                src="https://www.google.com/maps?q=69+Gradwell+Drive+Scarborough+Ontario+M1M+2N1&output=embed"
                className="w-full h-full"
                loading="lazy"
              />
            </div>
          </div>

          <Reveal delay={0.15}>
            <LeadForm />
          </Reveal>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ContactPage;
